import { render, staticRenderFns } from "./EGiftCardPreview.vue?vue&type=template&id=0a2b2c42&scoped=true"
import script from "./EGiftCardPreview.vue?vue&type=script&lang=js"
export * from "./EGiftCardPreview.vue?vue&type=script&lang=js"
import style0 from "./EGiftCardPreview.vue?vue&type=style&index=0&id=0a2b2c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b2c42",
  null
  
)

export default component.exports